import { ValidateRule } from '../constant/validateRules';
import { FormValidationService } from '../services/formValidationService';

/**
 * バリデーション関数の返り値
 */
interface ValidateFuncReturnType {
  /**
   * バリデーション結果
   */
  isValid: boolean;
  /**
   * バリデーションエラーのルール
   */
  invalidRules: ValidateRule[];
}

/**
 * フォームのバリデーション関数を作成するファクトリ
 */
export class FormValidateFunctionFactory {
  private static validationKeyMap = {
    [ValidateRule.Required]: FormValidationService.validateRequired,
    [ValidateRule.HalfWidthNumber]: FormValidationService.validateHalfWidthNumber,
    [ValidateRule.HalfWidthRealNumber]: FormValidationService.validateHalfWidthRealNumber,
    [ValidateRule.NegativeNumber]: FormValidationService.validateNegativeNumber,
    [ValidateRule.MemoInvalidChar]: FormValidationService.validateMemoInvalidChar,
    [ValidateRule.MemoTooMuchLength]: FormValidationService.validateMemoTooMatchLength,
  };
  /**
   * 指定されたルールに基づいてバリデーション関数を作成します
   * @param rules - バリデーションルール
   * @returns ルールに基づいて値をバリデーションする関数
   */
  public static create(rules: readonly ValidateRule[]): (value: any) => ValidateFuncReturnType {
    if (!rules || rules.length === 0) {
      return () => {
        return { isValid: true, invalidRules: [] };
      };
    }

    return (value: any) => {
      const invalidRules: ValidateRule[] = [];
      for (const rule of rules) {
        if (this.validationKeyMap[rule]) {
          if (!this.validationKeyMap[rule](value)) {
            invalidRules.push(rule);
          }
        }
      }
      return {
        isValid: invalidRules.length === 0,
        invalidRules,
      };
    };
  }
}
